import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

const HasPermission = (action) => {
    const { user, permissions } = useContext(AuthContext);
    if (user?.role === "superUser") return true
    if (permissions?.includes(action)) return true
    else return false
}

export default HasPermission
